import { render, staticRenderFns } from "./hander.vue?vue&type=template&id=6d3816e8&scoped=true&"
import script from "./hander.vue?vue&type=script&lang=js&"
export * from "./hander.vue?vue&type=script&lang=js&"
import style0 from "./hander.vue?vue&type=style&index=0&id=6d3816e8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d3816e8",
  null
  
)

export default component.exports